import { BannerType, CarouselCardType, SegmentLocationNames } from './analytics.const';

// The RMT5 home banner sends the same values, so one funnel can show all UIs.
export const DING_TOP_UP_BANNER_ANALYTICS = {
  bannerType: BannerType.MobileTopUp,
  alertName: BannerType.MobileTopUp,
  campaignId: 'home_mobile_top_up',
  carouselCardType: CarouselCardType.CrossSell,
  messageId: 'home_banner_mobile_top_up',
  location: SegmentLocationNames.Home,
};

export enum DingTopUpErrorCode {
  TokenUnavailable = 'TOKEN_UNAVAILABLE',
  TokenExpired = 'TOKEN_EXPIRED',
  CheckoutFailed = 'CHECKOUT_FAILED',
}



// WEBPACK FOOTER //
// ./src/model/types/ding-top-up.const.ts